import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	uuid: '',
	name: null,
	tab: null,
	open:false,
	attendancePolicyDetails:{},
	drawerData:{},
	title:'',
	status:""
}

const drawerSlice = createSlice({
	name: 'drawer',
	initialState,
	reducers: {
		openDrawer: (state, action) => {
			// if (action.payload.job) return { ...state, ...{ id: action.payload.id, name: action.payload.name } };
			return { ...state, ...action.payload }
		},
		closeDrawer: (state) => {
			return { ...initialState };
		},
		setOpen:(state,action)=>{
		state.open=action.payload
		},
		setDrawerData:(state,action)=>{
			state.drawerData=action.payload
		}
	},
});

export const { openDrawer, closeDrawer,setOpen, setDrawerData } = drawerSlice.actions;

export default drawerSlice.reducer